export default {
  apiKey: 'AIzaSyC-RDW0_8Sskl6meCwwjGR2IPyvq4sAFGE',
  authDomain: 'supreme-potato-9dd7e.firebaseapp.com',
  databaseURL: 'https://supreme-potato-9dd7e.firebaseio.com',
  projectId: 'supreme-potato-9dd7e',
  storageBucket: 'supreme-potato-9dd7e.appspot.com',
  messagingSenderId: '423667596593',
  appId: '1:423667596593:web:35e8ad16068c1b70718410',
  measurementId: 'G-1Q5TE16RM9'
};
